import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const SiteStatusConnectedGlyph = /*#__PURE__*/createElement("g", {
  id: "site_status_connected",
  fill: "none",
  style: {
    transform: 'scale(2.5)'
  }
}, /*#__PURE__*/createElement("ellipse", {
  opacity: "0.2",
  cx: "16",
  cy: "16.3433",
  rx: "16",
  ry: "16.3433",
  fill: "#1AC632"
}), /*#__PURE__*/createElement("ellipse", {
  cx: "16.0001",
  cy: "16.3436",
  rx: "12.6316",
  ry: "12.9026",
  fill: "white"
}), /*#__PURE__*/createElement("ellipse", {
  cx: "16",
  cy: "16.3433",
  rx: "9.26316",
  ry: "9.46194",
  fill: "#1AC632"
}));
const SiteStatusConnected = createSvg({
  name: 'site_status_connected',
  path: SiteStatusConnectedGlyph
});

export default SiteStatusConnected;
export { SiteStatusConnectedGlyph };
